// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createListDetailButtonStyle, linkLikeButtonCss } from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import IconPrint from "@conklin/XDL/Icons/IconPrint";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { rfqConfirmationHeaderStyles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationHeader";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { css } from "styled-components";

const buttonStyles: ButtonPresentationProps = {
    css: css`
        min-height: 28px;
        span {
            font-size: 11px;
            white-space: nowrap;
        }
    `,
};

rfqConfirmationHeaderStyles.viewQuotesButton = {
    ...mergeWithCss(buttonStyles, {
        variant: "secondary",
        css: css`
            max-width: 128px;
        `,
    }),
};

rfqConfirmationHeaderStyles.printButton = {
    ...mergeWithCss(createListDetailButtonStyle(IconPrint), linkLikeButtonCss),
};
rfqConfirmationHeaderStyles.continueButton = {
    ...mergeWithCss(buttonStyles, {
        css: css`
            margin-left: 0;
            max-width: 142px;
        `,
    }),
};

rfqConfirmationHeaderStyles.buttonGridItem = {
    css: css`
        justify-content: flex-start;
        align-items: center;
        gap: 24px;
        ${xScreen("lte", "md")} {
            flex-wrap: wrap;
        }
    `,
    width: 12,
};
